module.exports = __webpack_public_path__ + "img/trading1.bc617320.svg";